import React from 'react';
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import InputError from 'evcharging/components/InputError';
import Form from 'evcharging/components/Form';
import useInput from 'evcharging/hooks/useInput';
import useFormResponse from 'evcharging/hooks/useFormResponse';
import ResponsePopup from 'evcharging/components/ResponsePopup';
import Input from 'evcharging/components/Input';
import Loader from 'evcharging/components/Loader';
import Button from 'evcharging/components/Button';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Spacer from 'evcharging/components/Spacer';
import sendPhoneConfirmation from 'evcharging/app/client/sendPhoneConfirmation';
import { PHONE_NUMBER } from 'evcharging/app';
import { useRouter } from 'next/router';
import useI18n from 'evcharging/hooks/useI18n';
import useTheme from 'evcharging/hooks/useTheme';

const EnterPhoneForm = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const phone = useInput();
  const { pathname } = useRouter();
  const { t } = useI18n();

  const { isLoading, onSubmit, ...popup } = useFormResponse(
    { phone },
    async (values: Record<string, string>) => {
      await sendPhoneConfirmation({ ...values, name: 'Guest' });
    }
  );

  return (
    <Form onSubmit={onSubmit}>
      <ResponsePopup {...popup} />
      <div className={styles.root}>
        <Responsible fractions={[66, 33]} space={0}>
          <Input
            placeholder={t('rebates.phone')}
            name={'phone'}
            onChangeValue={phone.onChangeValue}
            value={phone.value}
            onBlur={() => phone.setError('')}
            invalid={!!phone.error}
            noSpace
            type={'number'}
          >
            <InputError message={phone.error} />
          </Input>
          <Box paddingTop={1}>
            <Spacer value={0} mobile={12} />
            <Button type="submit" disabled={isLoading} fullWidth height={55} borderRadius={5}>
              {isLoading ? <Loader /> : t('rebates.consultation')}
            </Button>
          </Box>
        </Responsible>
        <Spacer value={15} mobile={21} />
        <p className={styles.text}>
          {t('rebates.call')} <b style={{ color: '#333' }}>{PHONE_NUMBER}</b>
        </p>
      </div>
    </Form>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    padding: 30px 40px;
    background: #f6f8f9;
    border-radius: 6px;

    ${theme.breakpoints.mobile.down} {
      padding: 24px 16px;
    }
  `,
  text: css`
    max-width: 825px;
    font-style: normal;
    font-weight: 400;
    font-size: 21px;
    line-height: 150%;
    ${theme.breakpoints.mobile.down} {
      font-size: 18px;
    }
  `,
});

export default EnterPhoneForm;
